import useCacheQuery, { CacheQueryOpts, CacheQueryOutput } from "../../core/services/query/hooks/useCacheQuery";
import TransportLocation from "../types/TransportLocation";
import useAPIClient from "../../core/services/API/hooks/useAPIClient";

type Output = TransportLocation;

/**
 * Hook to get a transport location by ID
 * GET /transport_locations/{id}
 */
export default function useTransportLocationGetByID(
    id?: number | string,
    options?: CacheQueryOpts
): CacheQueryOutput<Output> {
    const client = useAPIClient();

    return useCacheQuery<Output>(
        ["transport-location", id],
        () => client.get<Output>(`transport_locations/${id}`),
        options,
    );
}
